import { create } from 'zustand';
import Conversation from '@/types/conversationType';
import useUserStore from './userState';
import ConversationReqRepository from '@/types/conversationReqRepositoryType';
import createConversationForRepository from '@/apis/createConversationForRepository';
import headerObject from '@/types/headerObj';
import emptyHeaderObj from '@/types/emptyHeaderObj';
import useOrganizationStore from './orgState';

interface ConversationState {
  addConversationForLoggedOutUser: (
    convReq: ConversationReqRepository,
    convUUID?: string
  ) => Promise<Conversation>;
}

const headerObj: headerObject = emptyHeaderObj;
headerObj.Useruuid = useUserStore.getState().user?.UserUUID;
headerObj.Useremail = useUserStore.getState().user?.Email;
headerObj.Username = useUserStore.getState().user?.FirstName;
headerObj.Orgname = useOrganizationStore.getState().organization?.OrgName;
headerObj.Orguuid = useOrganizationStore.getState().organization?.OrgUUID;

const useConversationStore = create<ConversationState>()(() => ({
  addConversationForLoggedOutUser: async (
    convReq: ConversationReqRepository,
    convUUID?: string
  ) => {
    const newUUID =
      convUUID || (await createConversationForRepository(convReq, headerObj));
    const conversationObject: Conversation = {
      UUID: newUUID,
      Name: convReq.Name,
      UserUUID: '',
      RepositoryUUID: '',
      IsActive: true,
      StartDate: '',
      LastUpdated: '',
      TicketUUID: '',
      VectorDBUrl: convReq.VectorDBUrl,
    };
    return conversationObject;
  },
}));

// export const currentConversationId = <string | null>({
//       key: 'currentConversationId',
//       default: null,
//     });
export default useConversationStore;
